import { DailyReportService } from './remote/DailyReportService';
import { ReportDTO } from '../../src_server/entity/dto/ReportDTO';
import { LocalData } from '../utils/LocalData';
import { dayjs, DT_FORMAT } from '../../src_server/common/momentExtends';
import { Session } from '../utils/Session';

export type LocalReports = { class_id: number; date: string; dto: ReportDTO }; //ディクショナリ形を定義
export class DailyReportServiceExt extends DailyReportService {
  public getLocal(): LocalReports[] {
    let reports = LocalData.get<LocalReports[]>('REPORT');
    if (!reports) {
      reports = [];
    }
    return reports;
  }

  public getReportFromLocal(class_id: number): LocalReports {
    const db = this.getLocal();
    const result = db.filter((i) => i.class_id === class_id);
    return result[0];
  }

  public saveLocal(class_id: number, value: ReportDTO) {
    const db = this.getLocal();
    const removed = db.filter((i) => i.class_id !== class_id);
    removed.push({ class_id: class_id, date: dayjs().format(DT_FORMAT), dto: value });
    LocalData.set<LocalReports[]>('REPORT', removed);
  }

  public laoadTemp(class_id: number): ReportDTO | null {
    let reports = Session.get<{ [class_id: number]: ReportDTO }>('REPORT_CURRENT');
    if (!reports) {
      reports = {};
    }
    return reports[class_id];
  }

  public saveTemp(class_id: number, value: ReportDTO) {
    let reports = Session.get<{ [class_id: number]: ReportDTO }>('REPORT_CURRENT');
    if (!reports) {
      reports = {};
    }
    reports[class_id] = value;
    Session.set<{ [class_id: number]: ReportDTO }>('REPORT_CURRENT', reports);
  }
}
